<style lang="scss" scoped>
.reservation-list {
}
.img {
  width: 80px;
  height: 80px;
  border-radius: 5px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100%;
  background-color: #fff;
  float: left;
  margin-right: 20px;
  border: 1px solid #eee;
}
.title,
.submit-time {
  padding: 0;
  margin: 0;
}
.title {
  height: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tip {
  font-size: 12px;
  color: #ccc;
}
</style>

<template>
  <div class="reservation-list">
    <div class="container">
      <div class="color3 mb-l pb-l">填写任意选项进行筛选</div>
      <el-form ref="form" size="mini">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="用户手机号" label-width="95px">
              <el-input v-model="params.mobile" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="提交预约时间" label-width="100px">
              <el-date-picker v-model="params.time" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" align="right"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="mini" @click="search">筛选</el-button>
            <el-button size="mini" @click="clear">清空</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="container">
      <el-radio-group v-model="params.status" size="mini" style="margin: 10px 0">
        <el-radio-button label="0">全部预约</el-radio-button>
        <el-radio-button label="1">待反馈</el-radio-button>
        <el-radio-button label="2">已确认预约</el-radio-button>
        <el-radio-button label="3">体验完成</el-radio-button>
        <el-radio-button label="4">已拒绝</el-radio-button>
      </el-radio-group>
      <el-table :data="list" style="width: 100%">
        <el-table-column label="预约服务" width="360px">
          <template slot-scope="scope">
            <div class="img" :style="{ backgroundImage: `url(${scope.row.product.imagesList.length ? scope.row.product.imagesList[0] : ''})` }"></div>
            <div style="padding-top: 14px;">
              <h4 class="title" style="margin-bottom: 3px;">{{ scope.row.product.name }}</h4>
              <p class="submit-time">提交时间 {{ new Date(scope.row.createdat * 1000).toLocaleString() }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="user.nickname" label="预约人" width="120px" />
        <el-table-column label="手机号" width="110px">
          <template slot-scope="scope">
            {{ scope.row.mobile || scope.row.user.mobile }}
          </template>
        </el-table-column>
        <el-table-column prop="note" label="给顾客留言" />
        <el-table-column label="到店时间" width="160px">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">待商户确认</span>
            <span v-if="scope.row.status == 2 || scope.row.status == 3">{{ scope.row.time ? $utils.formatTimestamp(scope.row.time * 1000) : '随时可到店' }}</span>
            <span v-if="scope.row.status == 4">/</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-show="scope.row.status == 1" size="mini" @click="() => refuse(scope.row)">拒绝</el-button>
            <el-button type="primary" v-show="scope.row.status == 1" size="mini" @click="() => confirm(scope.row)">确认</el-button>
            <el-button v-show="scope.row.status == 2" size="mini" @click="() => finish(scope.row)" type="primary">顾客已体验</el-button>
            <el-tag type="success" v-show="scope.row.status == 3">已完成</el-tag>
            <el-tag type="warning" v-show="scope.row.status == 4">已拒绝</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="list.length" class="table-bottom">
        <el-button v-if="hasMore" :loading="loadmore" @click="getList" size="small" type="primary">加载更多</el-button>
        <p v-else style="color: #ccc; font-size: 12px;">已加载全部，没有更多了</p>
      </div>
    </div>
    <el-dialog :title="current.status == 2 ? '确认预约' : '拒绝预约'" :visible.sync="dialogVisible" width="40%">
      <el-form size="mini">
        <el-form-item label="顾客到店时间" v-if="current.status == 2">
          <el-date-picker v-model="current.time" type="datetime" :disabled="noLimit" :default-value="new Date()" :picker-options="{ disabledDate }" placeholder="请选择顾客到店时间" />
        </el-form-item>
        <el-form-item v-if="current.status == 2">
          <el-checkbox v-model="noLimit">不限制顾客到店时间</el-checkbox>
          <span class="tip">营业期间随时可到店</span>
        </el-form-item>
        <el-form-item label="留言给顾客">
          <el-input v-model="current.note" type="textarea" placeholder="请输入留言" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="update" :disabled="current.status == 2 && !current.time && !noLimit" :loading="okLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

export default {
  name: 'reservation-list',
  data() {
    return {
      params: {
        idlessthan: 0,
        count: 20,
        status: 0,
        userid: 0,
        usermobile: '',
        createdatgreaterthan: 0,
        createdatlessthan: 0,
        time: []
      },
      list: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      hasMore: true,
      loadmore: false,
      dialogVisible: false,
      current: {
        time: new Date()
      },
      noLimit: false,
      okLoading: false
    };
  },
  watch: {
    'params.status': function() {
      this.list = [];
      this.getList();
    },
    dialogVisible(v) {
      if (!v) {
        this.noLimit = false;
        this.current = {
          time: new Date()
        };
        this.okLoading = false;
      }
    }
  },
  created() {
    this.token = getToken();
    this.getList();
  },
  methods: {
    async getList() {
      this.dialogVisible = false;

      this.loadmore = true;
      const { scrollY } = window;
      this.params.createdatgreaterthan = 0;
      this.params.createdatlessthan = 0;
      if (this.params.time.length === 2) {
        this.params.createdatgreaterthan = parseInt(this.params.time[0].getTime() / 1000);
        this.params.createdatlessthan = parseInt(this.params.time[1].getTime() / 1000);
      }
      // 根据手机号获取用户id
      if (this.params.mobile) {
        const res = await rpc(
          'StoreUserService.GetUserList',
          M('UserListQueryRequest', {
            token: M('Token', { token: this.token }),
            mobile: this.params.mobile,
            count: 1,
            order: 0
          })
        );
        this.params.userid = res.userlistList.length ? res.userlistList[0].id : 0;
      }
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;
      const res = await rpc(
        'StoreReservationService.GetReservationList',
        M('ReservationListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      if (res.reservationlistList.length === 0) {
        this.loadmore = false;
        this.hasMore = false;
        return;
      }
      const useridlist = res.reservationlistList.map(item => item.userid);
      const productidlist = res.reservationlistList.map(item => item.productid);
      const reslist = await Promise.all([
        rpc(
          'StoreUserService.GetUserList',
          M('UserListQueryRequest', {
            token: M('Token', { token: this.token }),
            idlistList: useridlist,
            count: useridlist.length,
            order: 0
          })
        ),
        rpc(
          'StoreProductService.GetProductList',
          M('ProductListQueryRequest', {
            token: M('Token', { token: this.token }),
            idlistList: productidlist,
            sortby: 1,
            sort: 1,
            count: productidlist.length
          })
        )
      ]);
      res.reservationlistList.forEach(item => {
        item.user = reslist[0].userlistList.find(v => v.id === item.userid);
        item.product = reslist[1].productlistList.find(v => v.id === item.productid);
      });
      this.list = this.list.concat(res.reservationlistList);
      this.hasMore = res.reservationlistList.length;
      this.loadmore = false;
      if (this.params.idlessthan !== 0) {
        window.scroll(0, scrollY);
      }
    },

    search() {
      this.list = [];
      this.getList();
    },
    clear() {
      this.params = {
        idlessthan: 0,
        count: 20,
        status: 0,
        userid: 0,
        usermobile: '',
        createdatgreaterthan: 0,
        createdatlessthan: 0,
        time: []
      };
      this.list = [];
      this.getList();
    },

    refuse(row) {
      this.current = JSON.parse(JSON.stringify(row));
      this.current.time = this.current.time ? new Date(this.current.time * 1000) : new Date();
      this.current.status = 4;
      this.dialogVisible = true;
    },
    confirm(row) {
      this.current = JSON.parse(JSON.stringify(row));
      this.current.time = this.current.time ? new Date(this.current.time * 1000) : new Date();
      this.current.status = 2;
      this.dialogVisible = true;
    },
    finish(row) {
      this.$confirm('确认已到店体验?', '顾客是否已经到店体验完毕？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {
          this.current = JSON.parse(JSON.stringify(row));
          this.current.time = this.current.time ? new Date(this.current.time * 1000) : new Date();
          this.current.status = 3;
          this.update();
        })
        .catch(() => {});
    },

    update() {
      this.okLoading = true;
      this.current.time = parseInt(this.current.time.getTime() / 1000);
      if (this.current.status == 2 && this.noLimit) {
        this.current.time = 0;
      }
      rpc(
        'StoreReservationService.UpdateReservation',
        M('ReservationWithTokenRequest', {
          token: M('Token', { token: this.token }),
          reservation: M('Reservation', this.current)
        })
      ).then(res => {
        const row = this.list.find(v => v.id === res.id);
        res.user = row.user;
        res.product = row.product;
        this.list.splice(this.list.findIndex(v => v.id === res.id), 1, res);
        this.okLoading = false;
        this.dialogVisible = false;
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      });
    },
    disabledDate(curr) {
      return curr < new Date();
    }
  }
};
</script>
